import { useQuery } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'
import type { components } from '@/lib/generated/api-types'

// Type exports for convenience
export type VersionResponse = components['schemas']['VersionResponse']

// Get server version info
export function useVersion() {
  return useQuery({
    queryKey: queryKeys.version,
    queryFn: async () => {
      const { data, error } = await client.GET('/api/v1/version')
      if (error) throw error
      return data
    },
    staleTime: 60 * 60 * 1000, // 1 hour - version info rarely changes
    retry: 1, // Only retry once for version info
  })
}
